import { usePlayWalletSync } from 'shared/hooks/use-play-wallet-sync'

/** Publishes the wallet that plays: the connected one while it is linked. */
export const PlayWalletEffect = () => {
  usePlayWalletSync()
  return null
}
